// Per-hex unit slot layout, shared by the renderer (where units are drawn) and
// input (where they're hit-tested) so a clicked point matches the drawn figure.
// Up to HEX_CAP units share a hex (server-enforced): slots fill the middle
// first, then corners — the geometry supports all seven positions.

/** How far toward a corner (0 = centre, 1 = corner) a slot sits, in hex radii. */
export const SLOT_FRAC = 0.5

/** Slot offsets in hex-radius units: index 0 is the centre, 1..6 the corners. */
export const UNIT_SLOTS: { dx: number; dy: number }[] = [{ dx: 0, dy: 0 }]
for (let i = 0; i < 6; i++) {
  const ang = (Math.PI / 180) * (30 + 60 * i) // pointy-top hex corner directions
  UNIT_SLOTS.push({ dx: Math.cos(ang) * SLOT_FRAC, dy: Math.sin(ang) * SLOT_FRAC })
}

/**
 * Assign each unit sharing a hex a distinct slot offset. Grouped by the unit's
 * logical hex (q,r) and ordered by id, so a unit keeps its slot while the hex's
 * occupants don't change — and the renderer and input agree on which figure sits
 * where. Returns a map from unit id to its offset (in hex-radius units).
 */
export function assignUnitSlots(
  units: Iterable<{ id: number; q: number; r: number }>,
): Map<number, { dx: number; dy: number }> {
  const byHex = new Map<string, number[]>()
  for (const u of units) {
    const k = u.q + ',' + u.r
    let arr = byHex.get(k)
    if (!arr) byHex.set(k, (arr = []))
    arr.push(u.id)
  }
  const out = new Map<number, { dx: number; dy: number }>()
  for (const arr of byHex.values()) {
    if (arr.length > 1) arr.sort((a, b) => a - b)
    for (let i = 0; i < arr.length; i++) out.set(arr[i], UNIT_SLOTS[i % UNIT_SLOTS.length])
  }
  return out
}
